import React, { FC } from 'react'

import styles from './LinkThumbnailPreloader.module.scss'

export const LinkThumbnailPreloader: FC = () => (
  <div className={styles.LinkThumbnailPreloader}>
    <div className={styles.LoaderImage} />
  </div>
)
